import { formatNumber } from "devextreme/localization";
import Heading from "./Heading";

type Props = {
  sectionHeading: string | undefined | React.ReactNode;
  items: {
    header: string;
    value: string | number | undefined;
    isPrecentage?: boolean;
    isCurrency?: boolean;
  }[];
  outerContainerClasses?: string;
  innerContainerClasses?: string;
  sectionClassName?: string;
  headingClassName?: string;
};

export default function KeyValueSection({
  items,
  sectionHeading,
  outerContainerClasses,
  sectionClassName,
  innerContainerClasses,
  headingClassName,
}: Props) {
  return (
    <div className={`flex flex-col gap-4 ${outerContainerClasses}`}>
      <Heading text={sectionHeading} className={headingClassName ?? ""} />
      <div
        className={`flex justify-between rounded-md border border-neutral-500 bg-white p-6 shadow-light ${innerContainerClasses}`}
      >
        {items?.map(({ header, value, isPrecentage, isCurrency = true }, i) => (
          <div key={i} className={`flex flex-col gap-4 ${sectionClassName}`}>
            <span className="font-medium">{header}</span>
            {typeof value === "number" && !isPrecentage && isCurrency ? (
              <span>{value ? formatNumber(value, "$ #,##0") : "—"}</span>
            ) : typeof value === "number" && isPrecentage ? (
              <span>{value ? formatNumber(value, "#.##%") : "—"}</span>
            ) : (
              <span>{value ? value : "—"}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
